var shouldShowAutopay = function (_a) {
    var isAutopayStatusUndefined = _a.isAutopayStatusUndefined, unformattedCurrentBalance = _a.unformattedCurrentBalance, isAutopayButtonVisible = _a.isAutopayButtonVisible, isPastDue = _a.isPastDue, isPreDelivery = _a.isPreDelivery;
    var positiveCurrentBalance = Number(unformattedCurrentBalance) > 0;
    return (!isAutopayStatusUndefined &&
        (positiveCurrentBalance || isPreDelivery) &&
        isAutopayButtonVisible &&
        !isPastDue);
};
export default shouldShowAutopay;
//# sourceMappingURL=shouldShowAutopay.js.map